<template>
  <b-modal id="post-modal" ref="postModal" size="lg" hide-footer>
    <loading :active.sync="loading"></loading>
    <div slot="modal-header" class="w-100 justify-content-center post-modal-header">
      <h3>Create a Post</h3>
      <button v-on:click="hidePostModal" class="close d-inline" type="button" aria-label="Close">x</button>
    </div>
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Title<span v-if="!title" class="red-text">*</span></label>
            <input v-bind:class="{'is-invalid': titleInvalid}" type="text" v-model="title" class="form-control" placeholder="Enter a post title">
          </div>
          <div class="form-group">
            <label>Description<span v-if="!description" class="red-text">*</span></label>
            <input v-bind:class="{'is-invalid': descriptionInvalid}" type="text" v-model="description" class="form-control" placeholder="Enter a post description">
          </div>
          <div class="container-fluid">
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label>Choose A Card Image<span v-if="!titleImage && !preloadedTitleImage" class="red-text">*</span></label>
                  <div class="custom-file">
                    <input @change="previewTitleImage"
                      type="file"
                      ref="image"
                      v-bind:class="{'is-invalid': titleImageInvalid}"
                      class="custom-file-input"
                      accept="image/png, image/jpeg">
                    <label class="custom-file-label"></label>
                  </div>
                  <img class="preview-image"
                    v-if="titleImage !== null"
                    v-bind:src="titleImage"
                    v-on:click="titleImage = null"
                    alt="not working"/>
                  <img class="preview-image"
                    v-if="preloadedTitleImage !== null"
                    v-bind:src="preloadedTitleImage"
                    v-on:click="preloadedTitleImage = null"
                    alt="not working"/>
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label>Choose A Blog Image<span v-if="!blogImage && !preloadedBlogImage" class="red-text">*</span></label>
                  <div class="custom-file">
                    <input @change="previewBlogImage"
                      type="file"
                      v-bind:class="{'is-invalid': blogImageInvalid}"
                      ref="image"
                      class="custom-file-input"
                      accept="image/png, image/jpeg">
                    <label class="custom-file-label"></label>
                  </div>
                  <img class="preview-image"
                    v-if="blogImage !== null"
                    v-bind:src="blogImage"
                    v-on:click="blogImage = null"
                    alt="not working"/>
                  <img class="preview-image"
                    v-if="preloadedBlogImage !== null"
                    v-bind:src="preloadedBlogImage"
                    v-on:click="preloadedBlogImage = null"
                    alt="not working"/>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <label>Post Content<span v-if="!post" class="red-text">*</span></label>
              <textarea v-bind:class="{'is-invalid': postInvalid}" v-model="post" class="form-control" rows="16" placeholder="Write the post content here."></textarea>
              <small><a href="http://demo.showdownjs.com/" target="_blank">See documentaiton examples</a></small>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <button v-on:click="hidePostModal" class="btn btn-secondary">Cancel</button>
        </div>
        <div class="col-md-6">
          <button v-on:click="createPost" class="btn btn-primary">Submit</button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  async mounted () {
    if (this.$route.params.entry) {
      await this.getPost()
      this.preloadedTitleImage = 'https://s3.' + window.CONFIG.Region + '.amazonaws.com/' + window.CONFIG.PhotoBucketName + '/xsmall/' + this.userId + '/' + this.titleImage
      this.preloadedBlogImage = 'https://s3.' + window.CONFIG.Region + '.amazonaws.com/' + window.CONFIG.PhotoBucketName + '/xsmall/' + this.userId + '/' + this.blogImage
      this.blogImage = null
      this.titleImage = null
    }
  },
  data () {
    return {
      title: null,
      description: null,
      titleImage: null,
      preloadedTitleImage: null,
      post: null,
      blogImage: null,
      preloadedBlogImage: null,
      loading: false,
      postId: null,
      titleInvalid: false,
      descriptionInvalid: false,
      titleImageInvalid: false,
      blogImageInvalid: false,
      postInvalid: false,
      formInvalid: false,
      userId: null
    }
  },
  components: {
    Loading
  },
  computed: {
    ...mapGetters('user', [
      'getLastName',
      'getLegalFirstName',
      'getUserType'
    ]),
    ...mapGetters('business', [
      'getBusinessName'
    ])
  },
  methods: {
    hidePostModal () {
      this.$refs.postModal.hide()
    },
    showPostModal () {
      this.$refs.postModal.show()
    },
    previewBlogImage (event) {
      var input = event.target
      var that = this
      for (var i = 0; i < input.files.length; i++) {
        if (input.files && input.files[i]) {
          var reader = new FileReader()
          reader.onload = function (e) {
            var img = new Image()
            img.onload = function () {
              that.blogImage = e.target.result
            }
            img.src = e.target.result
          }
          reader.readAsDataURL(input.files[i])
        }
      }
    },
    previewTitleImage (event) {
      var input = event.target
      var that = this
      for (var i = 0; i < input.files.length; i++) {
        if (input.files && input.files[i]) {
          var reader = new FileReader()
          reader.onload = function (e) {
            var img = new Image()
            img.onload = function () {
              that.titleImage = e.target.result
            }
            img.src = e.target.result
          }
          reader.readAsDataURL(input.files[i])
        }
      }
    },
    async getPost () {
      var client = this.$store.getters.getBlogApigClientFactory
      var params = {
        id: this.$route.params.entry
      }
      var pathTemplate = '/blog/{id}'
      var method = 'GET'
      var additionalParams = {}
      var body = {}
      try {
        var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        this.blogImage = result.data.blog_image
        this.description = result.data.description
        this.post = result.data.post
        this.title = result.data.title
        this.titleImage = result.data.title_image
        this.postId = result.data.post_id
        this.userId = result.data.user_id
      } catch (error) {
        console.log(error)
      }
    },
    async createPost () {
      this.formInvalid = false
      if (!this.title) {
        this.titleInvalid = true
        this.formInvalid = true
      } else {
        this.titleInvalid = false
      }

      if (!this.description) {
        this.descriptionInvalid = true
        this.formInvalid = true
      } else {
        this.descriptionInvalid = false
      }

      if (!this.titleImage && !this.preloadedTitleImage) {
        this.titleImageInvalid = true
        this.formInvalid = true
      } else {
        this.titleImageInvalid = false
      }

      if (!this.blogImage && !this.preloadedBlogImage) {
        this.blogImageInvalid = true
        this.formInvalid = true
      } else {
        this.blogImageInvalid = false
      }

      if (!this.post) {
        this.postInvalid = true
        this.formInvalid = true
      } else {
        this.postInvalid = false
      }

      if (this.formInvalid) return

      this.loading = true
      var client = this.$store.getters.getBlogApigClientFactory
      var params = {}
      var pathTemplate = '/blog'
      var method = 'POST'
      var additionalParams = {}
      var body = {
        userType: this.getUserType,
        author_name: this.getUserType === 'user' ? this.getLegalFirstName + ' ' + this.getLastName : this.getBusinessName,
        title: this.title,
        description: this.description,
        post: this.post
      }
      if (this.titleImage !== null) body.title_image = this.titleImage
      if (this.blogImage !== null) body.blog_image = this.blogImage
      if (this.postId !== null) body.post_id = this.postId
      try {
        await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        this.hidePostModal()
        this.title = null
        this.description = null
        this.titleImage = null
        this.post = null
        this.blogImage = null
        this.$router.go()
        this.loading = false
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    }
  }
}
</script>

<style scoped>
.close {
  position: absolute;
  text-shadow: none;
  right: 1rem;
  top: 1rem;
  opacity: 1;
}

.btn-secondary {
  width: 100% !important;
}

.post-button {
  width: auto !important;
}

.preview-image {
  padding-top: .5rem;
}

.col-md-6 {
  margin-top: .5rem;
}

.red-text {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/insights/PostModal.vue